import { createQueryKeys } from '@lukemorales/query-key-factory';

import { GetReportsConfig } from '../clients/gateway.api';
import { getStats } from '../clients/stats.api';

interface AdminReportsParams extends GetReportsConfig {
    customerIds?: string[];
    supplierIds?: string[];
}

interface CustomerReportsParams extends GetReportsConfig {
    customerIds?: string[];
}

interface SupplierReportsParams extends GetReportsConfig {
    supplierIds?: string[];
}

export const reports = createQueryKeys('reports', {
    admin: (params: AdminReportsParams) => ({
        queryKey: [{ params }],
    }),
    customer: (params: CustomerReportsParams) => ({
        queryKey: [{ params }],
    }),
    supplier: (params: SupplierReportsParams) => ({
        queryKey: [{ params }],
    }),
    quickStats: {
        queryKey: null,
        queryFn: () => getStats(),
    },
});
